import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import styles from "./styles.module.scss";
import moment from "moment";

import { customTableStylesReport, fallbackIfEmpty } from "utils/Utils";

const Table = ({ dados, loading, actionFilter, totalRecords }) => {
  const columns = [
    {
      name: "Nome da empresa",
      selector: "name",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {d.name}
        </span>
      ),
    },
    {
      name: "CNPJ",
      selector: "cnpj",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => <span style={{ whiteSpace: "nowrap" }}>{d.cnpj}</span>,
    },
    {
      name: "Responsável",
      selector: "responsibleName",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.responsibleName)}
        </span>
      ),
    },
    {
      name: "E-mail do responsável",
      selector: "responsibleEmail",
      sortable: true,
      center: true,
      wrap: true,
      width: "280px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.responsibleEmail)}
        </span>
      ),
    },
    {
      name: "Telefone do reponsável",
      selector: "responsiblePhone",
      sortable: true,
      center: true,
      wrap: true,
      width: "280px",
      style: {
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
      },
      cell: (d) => (
        <span
          style={{
            textAlign: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflow: "visible",
            textOverflow: "unset",
            wordBreak: "break-word",
          }}
        >
          {fallbackIfEmpty(d.responsiblePhone)}
        </span>
      ),
    },
    {
      name: "Num. de licenças contratadas",
      selector: "numberOfLicences",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.numberOfLicences),
    },
    {
      name: "Num. de licenças utilizadas",
      selector: "totalLicensesInUse",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.totalLicensesInUse),
    },
    {
      name: "Origem",
      selector: "origin",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.origin),
    },
    {
      name: "Data de criação",
      selector: "creationDate",
      sortable: true,
      center: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) =>
        d.creationDate ? (
          <span style={{ whiteSpace: "nowrap" }}>
            {moment(d.creationDate).format("DD/MM/YYYY")}
          </span>
        ) : (
          "-"
        ),
    },
    {
      name: "Data de ativação",
      selector: "activationDate",
      sortable: true,
      center: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) =>
        d.activationDate ? (
          <span style={{ whiteSpace: "nowrap" }}>
            {moment(d.activationDate).format("DD/MM/YYYY HH:mm")}
          </span>
        ) : (
          "-"
        ),
    },
    {
      name: "Aceite aos termos",
      selector: "companyLicenceTermsAccepted",
      sortable: true,
      center: true,
      cell: (d) => <span>{Boolean(d.userLicenceTermsAccepted) ? "SIM" : "NÃO"}</span>,
    },
  ];

  // const customTableStyles = {
  //   table: {
  //     style: {
  //       tableLayout: "auto", // permite largura dinâmica das colunas
  //     },
  //   },
  //   cells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal", // permite quebra de linha
  //       overflow: "visible",
  //       textOverflow: "unset",
  //       wordBreak: "break-word",
  //       width: "150px",
  //     },
  //   },
  //   headCells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal",
  //       fontWeight: "bold",
  //       position: "relative", // necessário para que o sortable fique absoluto em relação ao th
  //       padding: "0 0 0 12px", // espaço pro ícone
  //     },
  //   },
  //   sortIcon: {
  //     style: {
  //       position: "absolute",
  //       top: "50%",
  //       right: "8px",
  //       transform: "translateY(-50%)",
  //       pointerEvents: "none", // opcional, evita que o clique no ícone interfira
  //     },
  //   },
  // };

  const tableData = {
    columns: columns,
    data: dados,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Empresas por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * dados.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => {
    return (
      <div className="tela-login-loading">
        <div className="loader-container" style={{ margin: "300px 0" }}>
          <div
            style={{
              position: "initial",
              margin: "initial",
            }}
            className="loader loader-center loader-big"
          ></div>
          <span
            style={{
              marginTop: 10,
              fontSize: 20,
            }}
          >
            Carregando dados...
          </span>
        </div>
      </div>
    );
  };

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={true}
      export={false}
    >
      <DataTable
        columns={columns}
        data={dados}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
